import assign from 'lodash/assign';

import { ApiService } from 'services/api.service';
import { ShopperAccountService } from 'services/shopperAccount.service';
import { LogoutButton } from 'components/logoutButton/logoutButton';
import { SaveAndCancel } from 'components/saveAndCancel/saveAndCancel';
import { ContactInfoForm } from 'components/contactInfoForm/contactInfoForm';
import { getSavedCartInfo, setSavedCartInfo } from 'services/cartUtils';

import { DisplayContactInfo } from '../displayContactInfo/displayContactInfo';
import template from './editAccountContactInfo.html';
import './editAccountContactInfo.scss';

export const EditAccountContactInfo = angular
    .module('checkout.components.editAccountContactAndDelivery.editAccountContactInfo', [
        ApiService,
        ShopperAccountService,
        ContactInfoForm,
        DisplayContactInfo,
        LogoutButton,
        SaveAndCancel
    ]).component('editAccountContactInfo', {
        bindings: {
            shopperAccount: '<',
            phoneNumberRequired: '<',
            onContactInfoSaved: '&',
            useNewCarts: '<'
        },
        template,
        controller: class EditAccountContactInfoCtrl {
            constructor(
                apiService,
                checkoutService,
                $mdDialog,
                $q,
                shopperAccountService,
                $rootScope
            ) {
                assign(this, {
                    apiService,
                    checkoutService,
                    $mdDialog,
                    $q,
                    shopperAccountService,
                    $rootScope
                });
            }

            $onInit() {
                this.unbindListener = this.$rootScope.$on('editAccountContactAndDelivery:Editing', (event, data) => {
                    if (data !== 'contactInfo') this.onCancelClicked();
                });
            }

            $onDestroy() {
                this.unbindListener();
            }

            $onChanges(changesObj) {
                if (changesObj && changesObj.shopperAccount) {
                    this.setFormModel(changesObj.shopperAccount.currentValue);
                }
            }

            setFormModel(shopperAccount) {
                this.formModel = {
                    email: shopperAccount.emailAddress,
                    phone: shopperAccount.phoneNumber,
                    firstName: shopperAccount.firstName,
                    lastName: shopperAccount.lastName,
                    emailOptIn: shopperAccount.emailOptIn
                };
            }

            onEditClicked() {
                this.showForm = true;
                this.$rootScope.$emit('editAccountContactAndDelivery:Editing', 'contactInfo');
            }

            onCancelClicked() {
                this.showForm = false;
                this.setFormModel(this.shopperAccount);
            }

            onSaveClicked() {
                if (this.contactInfoForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.contactInfoForm['$ctrl.contactInfoForm']);
                    return;
                }

                this.contactInfoSaving = true;

                const shopperAccount = {
                    ...this.shopperAccount,
                    emailAddress: this.formModel.email,
                    phoneNumber: this.formModel.phone,
                    emailOptIn: this.formModel.emailOptIn,
                    firstName: this.formModel.firstName,
                    lastName: this.formModel.lastName
                };

                if (!this.useNewCarts) {
                    this.$q.all([
                        this.apiService.account.update(shopperAccount),
                        this.shopperAccountService.applyContactInfoToCart(shopperAccount)
                    ]).then(([updatedAccount, updatedCart]) => {
                        this.onContactInfoSaved({ shopperAccount: updatedAccount, cart: updatedCart });
                        this.showForm = false;
                    }).finally(() => {
                        this.contactInfoSaving = false;
                    });
                } else {
                    this.apiService.account.update(shopperAccount)
                        .then((updatedAccount) => {
                            const updatedCart = {
                                ...getSavedCartInfo(),
                                contactInfo: {
                                    email: shopperAccount.emailAddress,
                                    phoneNumber: shopperAccount.phoneNumber
                                }
                            };
                            setSavedCartInfo(updatedCart);

                            this.onContactInfoSaved({ shopperAccount: updatedAccount, cart: updatedCart });
                            this.showForm = false;
                        }).finally(() => {
                            this.contactInfoSaving = false;
                        });
                }
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editAccountContactAndDelivery/editAccountContactInfo/editAccountContactInfo.js